export default __webpack_public_path__ + "static/media/tableView.3ad4da8d.svg";